<!--
  - 发药.
  -->
<template>
  <div>
    <div v-show="pageData.activeDiagRecord.chmedPrescriptionItemList.length>0">
      <!--  饮片处方 start  -->
      <div class="label-con flex flex-row align-center justify-between">
        <div class="flex flex-row align-center">
          <div class="icon" />
          <div class="label">饮片处方</div>
        </div>
      </div>
      <el-descriptions label-class-name="desc-label" :column="3" border>
        <el-descriptions-item label="发药仓库">
          {{ pageData.activeDiagRecord.chmedPrescription.positionName }}
        </el-descriptions-item>
        <el-descriptions-item label="加工方式">
          {{ pageData.activeDiagRecord.chmedPrescription.serveFeeSign|SERVE_FEE_SIGN }}
        </el-descriptions-item>
        <el-descriptions-item label="总剂数">
          {{ pageData.activeDiagRecord.chmedPrescription.doseNum }}
        </el-descriptions-item>
      </el-descriptions>
      <el-table :data="pageData.activeDiagRecord.chmedPrescriptionItemList" class="mb-10">
        <el-table-column prop="materielCode" label="药品编码" align="center" />
        <el-table-column prop="materielName" label="药品名称" align="center" />
        <table-select-item
          :width="80"
          :edit="false"
          code="qualitySign"
          name="品质标识"
          :options="[{key:'1',value:'一般'},{key:'2',value:'精品'}]"
        />
        <el-table-column prop="singleNum" label="单剂数量" align="center" />
        <el-table-column prop="decoctionName" label="煎法" align="center" />
        <el-table-column prop="salePrice" label="单价" align="center">
          <template #default="{row}">
            {{ row.salePrice.toFixed(2) }}
          </template>
        </el-table-column>
        <el-table-column prop="saleAmount" label="总价" align="center">
          <template #default="{row}">
            {{ (row.salePrice.toFixed(2)*row.singleNum).toFixed(2) }}
          </template>
        </el-table-column>
      </el-table>
      <!--  饮片处方 end  -->
      <!--  饮片出库清单 start  -->
      <div class="label-con flex flex-row align-center justify-between">
        <div class="flex flex-row align-center">
          <div class="icon" />
          <div class="label">饮片出库清单</div>
        </div>
        <el-button type="primary" size="small" :disabled="pageData.activeDiagRecord.chmedPrescription.head?.executeSign == '3'" @click="sendChMed">发药</el-button>
      </div>
      <el-table :data="pageData.sendChmedList" class="mb-10">
        <el-table-column width="120" prop="materielCode" label="药品编码" align="center" />
        <el-table-column width="120" prop="materielName" label="药品名称" align="center" />
        <el-table-column width="120" prop="supplierName" label="供应商" align="center" />
        <el-table-column prop="manufacturerName" label="生产商" align="center" />
        <el-table-column prop="batchCode" label="批次" align="center" />
        <el-table-column prop="number" label="数量" align="center" />
      </el-table>
      <!--  饮片出库清单 end  -->
    </div>
    <div v-show="pageData.activeDiagRecord.medPrescriptionItemList.length>0">
      <!--  中成药处方 start  -->
      <div class="label-con flex flex-row align-center justify-between">
        <div class="flex flex-row align-center">
          <div class="icon" />
          <div class="label">中成药处方</div>
        </div>
      </div>
      <el-descriptions label-class-name="desc-label" :column="3" border>
        <el-descriptions-item label="发药仓库">
          {{ pageData.activeDiagRecord.medPrescription.positionName }}
        </el-descriptions-item>
      </el-descriptions>
      <el-table :data="pageData.activeDiagRecord.medPrescriptionItemList">
        <el-table-column prop="materielCode" label="药品编码" align="center" />
        <el-table-column prop="materielName" label="药品名称" align="center" />
        <el-table-column prop="sellingNum" label="数量" align="center" />
        <el-table-column prop="medAdvice" label="医嘱" align="center" />
        <el-table-column prop="salePrice" label="单价" align="center">
          <template #default="{row}">
            {{ row.salePrice.toFixed(2) }}
          </template>
        </el-table-column>
        <el-table-column prop="saleAmount" label="总价" align="center">
          <template #default="{row}">
            {{ row.saleAmount.toFixed(2) }}
          </template>
        </el-table-column>
      </el-table>
      <!--  中成药处方 end  -->
      <!--  中成药出库清单 start  -->
      <div class="label-con flex flex-row align-center justify-between">
        <div class="flex flex-row align-center">
          <div class="icon" />
          <div class="label">中成药出库清单</div>
        </div>
        <el-button type="primary" size="small" :disabled="pageData.activeDiagRecord.medPrescription.head?.executeSign == '3'" @click="sendMed">发药</el-button>
      </div>
      <el-table :data="pageData.sendMedList">
        <el-table-column width="120" prop="materielCode" label="药品编码" align="center" />
        <el-table-column width="120" prop="materielName" label="药品名称" align="center" />
        <table-select-item
          :width="80"
          :edit="false"
          code="qualitySign"
          name="品质标识"
          :options="[{key:'1',value:'一般'},{key:'2',value:'精品'}]"
        />
        <el-table-column width="120" prop="supplierName" label="供应商" align="center" />
        <el-table-column prop="manufacturerName" label="生产商" align="center" />
        <el-table-column prop="batchCode" label="批次" align="center" />
        <el-table-column prop="number" label="数量" align="center" />
      </el-table>
      <!--  中成药出库清单 end  -->
    </div>
  </div>
</template>

<script>

import { postData } from "@/api/ik/data/dataApi"

export default {
  name: "DispatchMed",
  inject: ["pageData"],
  filters: {
    SERVE_FEE_SIGN(sign) {
      switch (sign) {
        case "00":
          return "不加工"
        case "01":
          return "代煎"
        case "11":
          return "制粒"
        case "21":
          return "细粉打粉"
        case "22":
          return "粗粉打粉"
        case "31":
          return "水丸制丸"
        case "32":
          return "蜜丸制丸"
        case "33":
          return "大蜜丸制丸"
        case "35":
          return "水蜜丸制丸"
        case "41":
          return "制瓶装膏"
        case "42":
          return "制袋装膏"
        case "43":
          return "制块装膏"
      }
    }
  },
  methods: {
    /**
     * 确认饮片发药
     */
    sendChMed() {
      const pd = {
        code: this.pageData.activeDiagRecord.chmedPrescription.code
      }
      postData("clinic/treatment/treatment/diagrecord/do/chmedsend", pd)
        .then(res => {
          this.$message.success("操作成功")
          if (this.pageData.activeDiagRecord.medPrescription.head?.executeSign === '3') {
            this.pageData.dispatchMed()
          }
          this.pageData.updateDiagRecord()
        })
    },
    /**
     * 确认成药发药
     */
    sendMed() {
      console.log("send", this.pageData.activeDiagRecord)
      const pd = {
        code: this.pageData.activeDiagRecord.medPrescription.code
      }
      postData("clinic/treatment/treatment/diagrecord/do/medsend", pd)
        .then(res => {
          this.$message.success("操作成功")
          if (this.pageData.activeDiagRecord.chmedPrescription.head?.executeSign === '3') {
            this.pageData.dispatchMed()
          }
          this.pageData.updateDiagRecord()
        })
    }
  }
}
</script>

<style scoped lang="scss">
.label-con {
  margin-bottom: 12px;

  .icon {
    width: 4px;
    height: 14px;
    background: #165DFF;
    border-radius: 0 0 0 0;
    margin-right: 8px;
  }

  .label {
    font-family: PingFang SC, PingFang SC, serif;
    font-weight: bold;
    font-size: 16px;
    color: #1D2129;
    line-height: 24px;
    text-align: left;
    font-style: normal;
    text-transform: none;
  }
}

::v-deep .desc-label {
  width: 120px;
}
</style>
